import { __assign } from "tslib";
import React from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { officialEmotes } from './official-emotes';
import { DA_COMM_EMOTE } from './types';
import styles from './emote-styles.scss';
var OfficialEmote = function (_a) {
    var decoratedText = _a.decoratedText, children = _a.children, themedStyles = _a.themedStyles;
    var emote = officialEmotes[decoratedText.trim()];
    if (!emote) {
        return React.createElement("span", null, children);
    }
    var emoteStyle = {
        backgroundImage: "url(https://e.deviantart.net/emoticons" + emote.src + ")",
        width: emote.width + "px",
        height: emote.height + "px",
        imageRendering: 'pixelated',
    };
    return (React.createElement("span", { contentEditable: false, className: themedStyles.emote, title: decoratedText, style: emoteStyle }, decoratedText));
};
OfficialEmote.displayName = 'OfficialEmote';
var CommunityEmote = function (_a) {
    var children = _a.children, themedStyles = _a.themedStyles, entity = _a.entity;
    if (!entity || !entity.getData) {
        return React.createElement("span", null, children);
    }
    var _b = entity.getData(), src = _b.src, width = _b.width, height = _b.height, url = _b.url, title = _b.title;
    var emoteStyle = {
        backgroundImage: "url(" + src + ")",
        backgroundSize: 'contain',
        width: width + "px",
        height: height + "px",
        color: 'transparent',
    };
    return (React.createElement("a", { href: url, className: themedStyles.emote, title: title, style: emoteStyle }, children));
};
CommunityEmote.displayName = 'CommunityEmote';
var Emote = function (props) {
    var themedStyles = mergeStyles({
        styles: styles,
        theme: props.theme,
    });
    if (!props.entityKey) {
        return null;
    }
    var entity = props.contentState.getEntity(props.entityKey);
    if (entity && entity.getType() === DA_COMM_EMOTE) {
        return (React.createElement(CommunityEmote, __assign({}, props, { entity: entity, themedStyles: themedStyles }), props.children));
    }
    return (React.createElement(OfficialEmote, __assign({}, props, { themedStyles: themedStyles }), props.children));
};
Emote.displayName = 'Emote';
export default Emote;
//# sourceMappingURL=emote-component.js.map